import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constant/app.constants';


@Injectable()
export class OemService {

  constructor(private http: HttpClient) {
  }

  getOemsList(permissions) {
    console.log("permissions in service", permissions);
    return this.http.post<any>(AppConstants.SITE_URL + 'oems', { permissions });
  }

}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/oem.service.ts